import { createContext, useContext } from "react";

// M20 (ADR-042 D4): доступ до навчального wizard з будь-якої сторінки (напр.
// кнопка «Пройти навчання знову» у профілі). Дефолт — no-op, щоб компоненти
// unit-тестувались поза провайдером (той самий патерн, що LayoutWidthContext).
export interface OnboardingApi {
  /** Відкрити wizard вручну (restart → IN_PROGRESS, зберігає прогрес). */
  start: () => void;
}

export const OnboardingContext = createContext<OnboardingApi>({ start: () => {} });

export function useOnboarding(): OnboardingApi {
  return useContext(OnboardingContext);
}
